import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=6bd28669&scoped=true&"
import script from "./Copy.vue?vue&type=script&lang=ts&"
export * from "./Copy.vue?vue&type=script&lang=ts&"
import style0 from "./Copy.vue?vue&type=style&index=0&id=6bd28669&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd28669",
  null
  
)

export default component.exports